// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__BEDid","content":"NotFound_content__1b9bZ","fadeIn":"NotFound_fadeIn__Sgq6Y","button":"NotFound_button__tmXsI"};